import { Hub, BrowserClient } from '@sentry/browser';
import packageInfo from '../package.json.js';

let hub;
// This is our project dsn
const dsn = 'https://3594f287200410a42d2a8cd949cde4d7@o354215.ingest.sentry.io/4505986015887360';
const initializeSentry = () => {
    hub = new Hub(new BrowserClient({
        dsn,
        environment: process.env.REACT_APP_ENV,
        release: `autoshipment-checkout-front@${packageInfo.version}`,
    }));
    hub.configureScope((scope) => {
        scope.setTags({ version: packageInfo.version });
    });
};
const withSentryHub = () => {
    if (!hub) {
        initializeSentry();
    }
    return hub;
};

export { initializeSentry, withSentryHub };
//# sourceMappingURL=sentry-service.js.map
